export {
  default as brush,
  brushX,
  brushY,
  brushSelection
} from "./src/brush";



//////////////////
// WEBPACK FOOTER
// ./~/d3-brush/index.js
// module id = 1588
// module chunks = 3